import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Calendar, ArrowUpRight } from "lucide-react";
import { EVENTS } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function UpcomingEvents() {
    return (
        <section className="relative bg-white py-24 md:py-32" data-testid="upcoming-events-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4">Ch. 04 · Upcoming</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            Town halls
                            <br />
                            in your <span className="serif-italic text-pink">district</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            Three regional gatherings this quarter. Reserve a seat — limited to district residents and
                            registered participants.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    {EVENTS.map((e, i) => (
                        <motion.article
                            key={e.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            className="group relative flex flex-col overflow-hidden rounded-[24px] border border-ink/10 bg-white"
                            data-testid={`event-card-${e.id}`}
                        >
                            <div className="relative aspect-[4/3] overflow-hidden">
                                <img
                                    src={e.image}
                                    alt={e.title}
                                    className="h-full w-full object-cover"
                                    style={{ transition: "transform 700ms cubic-bezier(0.22,1,0.36,1)" }}
                                />
                                <span className="absolute left-4 top-4 rounded-full bg-white px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink">
                                    0{i + 1} / 03
                                </span>
                                <span className="absolute bottom-4 right-4 rounded-full bg-ink px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-white">
                                    {e.seats} seats
                                </span>
                            </div>
                            <div className="flex flex-col gap-3 p-6 md:p-7">
                                <h3 className="font-display text-[22px] font-semibold leading-tight tracking-tight text-ink">
                                    {e.title}
                                </h3>
                                <div className="flex items-center gap-2 text-[13px] text-slate-500">
                                    <Calendar className="h-3.5 w-3.5 text-pink" />
                                    {e.date}
                                </div>
                                <div className="flex items-center gap-2 text-[13px] text-slate-500">
                                    <MapPin className="h-3.5 w-3.5 text-pink" />
                                    {e.location}
                                </div>
                                <Link
                                    to="/events"
                                    className="mt-4 inline-flex items-center gap-1 text-[13px] font-semibold uppercase tracking-[0.24em] text-ink transition-colors hover:text-pink"
                                >
                                    Register <ArrowUpRight className="h-4 w-4" />
                                </Link>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
